// vim: set ts=2 sts=2 sw=2 et:
//
// This file is part of OpenLifter, simple Powerlifting meet software.
// Copyright (C) 2019 The OpenPowerlifting Project.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.

// WRPF on/off switch. A real checkbox (role="switch") styled as a toggle, so it stays keyboard- and
// screen-reader-friendly and tests can drive it like any checkbox. The whole label is clickable.

import React from "react";

import styles from "./Switch.module.scss";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  ariaLabel?: string;
  label?: React.ReactNode;
  description?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

const Switch: React.FC<Props> = (props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(event.currentTarget.checked);
  };

  const hasText = props.label !== undefined || props.description !== undefined;
  // Name the switch after its visible label (the label may hold an icon, so no aria-label string).
  const labelId =
    props.ariaLabel === undefined && props.id !== undefined && props.label !== undefined
      ? `${props.id}-label`
      : undefined;

  return (
    <label className={`${styles.switch} ${props.disabled ? styles.disabled : ""} ${props.className ?? ""}`}>
      <input
        id={props.id}
        className={styles.input}
        type="checkbox"
        role="switch"
        aria-label={props.ariaLabel}
        aria-labelledby={labelId}
        checked={props.checked}
        disabled={props.disabled}
        onChange={handleChange}
      />
      <span className={styles.track} aria-hidden="true">
        <span className={styles.thumb} />
      </span>
      {hasText ? (
        <span className={styles.text}>
          {props.label !== undefined ? (
            <span id={labelId} className={styles.label}>
              {props.label}
            </span>
          ) : null}
          {props.description !== undefined ? <small className={styles.description}>{props.description}</small> : null}
        </span>
      ) : null}
    </label>
  );
};

export default Switch;
